// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"27b48968","496":"82f36338"}[chunkId] + ".chunk.js";
};